/**
 * @name formatToCurrency
 * @deprecated This utility is deprecated and will be removed in the next major version. Please, use [PLS.UI](https://pages.git.i.mercedes-benz.com/dh-io-pls/dcps-product-pricing/) instead.
 * @description Returns the given number formatted as a price for the given locale
 *
 * @example
 * import { formatToCurrency } from '@workbench/core';
 *
 * const formattedPrice: string = formatToCurrency(120000, 'es-ES', 'EUR', 0, 0);
 */
export const formatToCurrency = (value: number, locale: string, currency: string, maximumFractionDigits: number = 0, minimumFractionDigits: number = 0): string => {
  return Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits,
    minimumFractionDigits,
  }).format(value);
};
